import Auth from "./components/AuthComponent";
import Admin from "./components/AdminComponent";

import Wrapper from "./pages/Wrapper";

import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import Forgot from "./pages/auth/Forgot";
import Reset from "./pages/auth/Reset";

import Terms from "./pages/Terms";

import Home from "./pages/Home";
import Request from "./pages/Request";
import Voucher from "./pages/request/Voucher";
import Receivers from "./pages/Receivers";
import History from "./pages/History";
import Show from "./pages/Show";
import Corrections from "./pages/Corrections";
import Claim from "./pages/Claim";
import Claims from "./pages/Claims";
import ClaimView from "./pages/ClaimView";
import Calculator from "./pages/Calculator";
import Offices from "./pages/Offices";
import About from "./pages/About";
import Legal from "./pages/Legal";
import Profile from "./pages/Profile";
import Password from "./pages/Password";
import NotFound from "./pages/404";


export default [
    ...applyRules(['guest'], [
        { path: '', component: Auth, redirect: { name: 'Login' }, children:
            [
                { path: '/login', name: 'Login', component: Login, meta: { title: 'Inicio' } },
                { path: '/register', name: 'Register', component: Register, meta: { title: 'Crear Cuenta' } },
                { path: '/password', component: Wrapper, children:
                    [
                        { path: 'reset', name: 'Forgot', component: Forgot, meta: { title: 'Recuperar Contraseña' } },
                        { path: 'reset/:token', name: 'Reset', component: Reset, meta: { title: 'Cambiar Contraseña' } }
                    ]
                }
            ]
        },
    ]),
    ...applyRules(['auth'], [
        { path: '', component: Admin, redirect: { name: 'Home' }, children:
            [
                { path: '/', name: 'Home', component: Home, meta: { title: 'Inicio' } },
                { path: '/request', name: 'Request', component: Request, meta: { title: 'Crear Pago' } },

                { path: '/request/result', name: 'Result', component: Voucher, meta: { title: 'Resumen del Pago' } },

                { path: '/accounts', name: 'Receivers', component: Receivers, meta: { title: 'Mis Favoritos' } },
                { path: '/history', name: 'History', component: History, meta: { title: 'Historial' } },
                { path: '/history/payment/:id', name: 'PaymentVoucher', component: Voucher, meta: { title: 'Detalles de Pago' } },
                { path: '/history/transfer/:id', name: 'TransferVoucher', component: Show, meta: { title: 'Detalles de Giro' } },
                { path: '/corrections', name: 'Corrections', component: Corrections, meta: { title: 'Correcciones' } },
                { path: '/claim', name: 'Claim', component: Claim, meta: { title: 'Crear Reclamo' } },
                { path: '/claims', name: 'Claims', component: Claims, meta: { title: 'Reclamos' } },
                { path: '/claims/v/:id', name: 'ClaimView', component: ClaimView, meta: { title: 'Detalles del Reclamo' } },
                { path: '/calculator', name: 'Calculator', component: Calculator, meta: { title: 'Calculadora' } },
                { path: '/offices', name: 'Offices', component: Offices, meta: { title: 'Oficinas' } },
                { path: '/about', name: 'About', component: About, meta: { title: 'Información' } },
                { path: '/legal', name: 'Legal', component: Legal, meta: { title: 'Información Legal' } },
                { path: '/profile/edit', name: 'Profile', component: Profile, meta: { title: 'Mi Perfil' } },
                { path: '/profile/password', name: 'Password', component: Password, meta: { title: 'Cambiar Contraseña' } },
            ]
        }
    ]),
    { path: '', component: Auth, redirect: {name: 'Login'}, children:
        [
            { path: '/terms', name: 'Terms', component: Terms, meta: { title: 'Términos & Condiciones' } }
        ]
    },
    { path: '', component: Wrapper, redirect: {name: 'Login'}, children:
        [
            { path: '/calculator/public', name: 'CalculatorPublic', component: Calculator, meta: { title: 'Calculadora' } },
        ]
    },
    { path: '/m', redirect: { name: 'Home' }, meta: { title: 'Inicio' } },
    { path: '*', component: NotFound, meta: { title: 'Página no Encontrada' } }
];

function applyRules(rules, routes) {
    for (let i in routes) {
        routes[i].meta = routes[i].meta || {};

        if (!routes[i].meta.rules) {
            routes[i].meta.rules = [];
        }
        routes[i].meta.rules.unshift(...rules);

        if (routes[i].children) {
            routes[i].children = applyRules(rules, routes[i].children);
        }
    }

    return routes
}
